import { SnapshotNode } from './TypedNode'

import type { RehajePlugin } from '../../types'

export class SnapshotPlugin implements RehajePlugin {
  visitors = {
    nodes: {
      Snapshot: SnapshotNode
    }
  }
}
